import React from "react";
import LiveData from "./LiveData";

function App() {
  return (
    <div>
      <LiveData />
    </div>
  );
}

export default App;
